function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Swatch from './swatch';

var handleClick = function handleClick(event, _ref) {
  var hex = _ref.hex,
      onSelect = _ref.onSelect;
  event.preventDefault();
  onSelect(event, {
    hex: hex
  });
};

var selectedStyle = {
  border: '1px solid #141414',
  borderRadius: '2px',
  margin: '3px'
};
var selectedInnerStyle = {
  border: '1px solid white',
  borderRadius: '2px'
};

var SwatchOption = /*#__PURE__*/function (_React$Component) {
  _inherits(SwatchOption, _React$Component);

  var _super = _createSuper(SwatchOption);

  function SwatchOption() {
    _classCallCheck(this, SwatchOption);

    return _super.apply(this, arguments);
  }

  _createClass(SwatchOption, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("li", {
        className: "slds-color-picker__swatch",
        style: this.props.workingColor && this.props.workingColor.hex === this.props.color ? selectedStyle : {},
        role: "presentation"
      }, /*#__PURE__*/React.createElement("a", {
        "aria-selected": this.props.workingColor && this.props.workingColor.hex === this.props.color,
        className: "slds-color-picker__swatch-trigger",
        onClick: function onClick(event) {
          handleClick(event, {
            hex: _this.props.color,
            onSelect: _this.props.onSelect
          });
        },
        ref: this.props.swatchOptionRef,
        role: "option",
        style: this.props.workingColor && this.props.workingColor === this.props.color ? selectedInnerStyle : {},
        tabIndex: this.props.tabIndex
      }, /*#__PURE__*/React.createElement(Swatch, {
        color: this.props.color,
        labels: this.props.labels
      })));
    }
  }]);

  return SwatchOption;
}(React.Component);

_defineProperty(SwatchOption, "displayName", 'SLDSSwatchOption');

export default SwatchOption;
//# sourceMappingURL=swatch-option.js.map